import { z } from 'zod';
export const StorageProviderSchema = z.enum(['local', 's3', 'gcs']);
export const FileSchema = z.object({
    id: z.string().uuid(),
    originalName: z.string(),
    mimeType: z.string(),
    size: z.number().int().positive(),
    uploadedBy: z.string().uuid(),
    createdAt: z.string().datetime(),
});
export const UploadResponseSchema = z.object({
    file: FileSchema,
    signedUrl: z.string().url().optional(),
});
export const FileQuerySchema = z.object({
    uploadedBy: z.string().uuid().optional(),
    mimeType: z.string().optional(),
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
});
//# sourceMappingURL=file.js.map